import { FactLocationV2 } from '../../../../../backend/src/case/fact/fact-location.entity';
import { SubsetFact } from '../../../../../backend/src/types/types';
import { Chip } from '@/new/components/chip';
import { Icon } from '@/new/components/icon';
import { CHIP_COLOURS } from '@/new/lib/chip-colours';
import { ChronologyFact } from '@/types';

interface Props {
  fact: SubsetFact | ChronologyFact;
  fullDocRow?: boolean;
  gotoDocReference: (docId: string, factId: string, pageNumber: number) => void;
}

const isChronologyFact = (fact: SubsetFact | ChronologyFact): fact is ChronologyFact => {
  return 'fact' in fact && 'chronologyId' in fact;
};

export const FactDocumentDetails = ({ fact, fullDocRow = true, gotoDocReference }: Props) => {
  const uploadDate = new Date(fact.createdDate);

  // Handle both SubsetFact and ChronologyFactV2
  const locations = isChronologyFact(fact) ? fact.fact.locations : fact.locations;
  const factId = isChronologyFact(fact) ? fact.fact.id : fact.id;

  return (
    <div className="flex flex-col gap-2">
      <p className="font-medium">Sources</p>

      {locations.map((factLocation: FactLocationV2, index: number) => {
        const pageNumber = factLocation?.boundingBoxes?.length > 0 ? factLocation?.boundingBoxes?.[0]?.pageNumber : 1;

        return (
          <div key={`${factLocation.docId}-${index}`} className="flex w-full flex-col gap-2 not-last:mb-2">
            <div className="flex w-full items-baseline gap-2">
              <div className="flex items-center gap-2">
                <p
                  onClick={() => gotoDocReference(factLocation.docId, factId, pageNumber)}
                  className="flex cursor-pointer items-center gap-1.25 text-xs break-all text-ellipsis text-blue-600 duration-150 hover:text-blue-700"
                >
                  <Icon className="lucide--file mb-0.25" />
                  <span className="line-clamp-1">{factLocation.doc?.file.name}</span>
                </p>

                <Chip className={CHIP_COLOURS.type}>{factLocation.doc?.type}</Chip>
              </div>

              {fullDocRow && (
                <div className="ml-auto text-xs whitespace-nowrap text-gray-500">
                  Uploaded{' '}
                  <span className="font-semibold">{`${uploadDate.getDate()}/${uploadDate.getMonth() + 1}/${uploadDate.getFullYear()}`}</span>
                </div>
              )}
            </div>

            <div className="border-l-2 border-gray-200 pl-4 text-gray-600">
              {factLocation.sources &&
                factLocation?.sources?.map((f, i) => {
                  return (
                    <div key={i} className="text-xs">
                      [Page{f.pages.includes(',') ? 's' : ''} {f.pages}]{' '}
                      {f.text && f.text.length > 900 ? f.text.slice(0, 900) + '...' : f.text}
                    </div>
                  );
                })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
